import React, { ReactNode } from 'react';
import { Breadcrumbs as MUIBreadcrumbs, Typography } from '@mui/material';
import { Link } from './link-component';
import { To } from 'react-router-dom';

type Props = {
  items: { label: ReactNode; to?: To }[];
};

export const Breadcrumbs = ({ items }: Props) => {
  return (
    <MUIBreadcrumbs aria-label="breadcrumb">
      {items.map((item, index) => {
        if (!item.to) {
          return (
            <Typography sx={{ color: 'text.primary' }} key={index}>
              {item.label}
            </Typography>
          );
        }

        return (
          <Link key={index} underline="hover" color="inherit" to={item.to}>
            {item.label}
          </Link>
        );
      })}
    </MUIBreadcrumbs>
  );
};
